/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * CenterWorkspace.tsx — Cente\1 \2orkspace (services/operator-web-app).
 */

import type { ReactNode } from 'react';
import { useTranslation } from '@/i18n';

/**
 * CenterWorkspace: client card header + scenario widget stack.
 * Plan: 02 — Customer Workspace; 14 wireframes.
 */
export function CenterWorkspace({ children }: { children: ReactNode }) {
  const t = useTranslation();
  return (
    <main
      id="main-content"
      tabIndex={-1}
      className="flex-1 min-w-0 flex flex-col overflow-hidden outline-none"
      aria-label={t('shell.workspace')}
    >
      <div className="flex-1 overflow-auto p-4">{children}</div>
    </main>
  );
}
